'use strict';
const { gql } = require('graphql-tag');
const { parse } = require('graphql');
var { fragments } = require('../fragments');
const sdk = require('../../../index');


var _parent = {};

let log = false;


var events = {
  init: p => (_parent = p),

  /**
   * @typedef {Object} EventOptions
   * @property {Int} actiontype_id - action type code (use events.actions)
   * @property {String} action - name of action type
   * @property {String} user - string representing user (usually email address)
   * @property {String} role - user role name (use role from user session data)
   * @property {Object} metadata - object containing
   * @property {Int} customer_id - (Optional) id of customer affected by event
   * @property {Int} move_id - (Optional) id of move affected by event
   * @property {Int} lane_id - (Optional) id of lane affected by event
   * @property {Int} location_id - (Optional) id of location affected by event
   * @property {Int} driver_id - (Optional) id of driver affected by event
   */

  /**
   * Build an eventlog record and inserts it into the database
   *
   * @param  {EventOptions} options - All the options
   * @returns {object} The built eventlog record object for insertion
   */
  buildAndCreate: async function (options) {
    try {
      let eventlogObj = await this.build(options);
      let response = await this.create(eventlogObj);
      console.log('buildAndCreate response', response)
      if (response && response.data && response.data.length > 0) {
        return response.data[0];
      } else {
        throw new Error("Error inserting eventlog into database")
      }
    } catch (err) {
      throw err;
    }
  },

  /**
   * Build an eventlog record for insertion
   *
   * @param  {EventOptions} options - All the options
   * @returns {object} The built eventlog record object for insertion
   */

  build: async function (options = {}) {
    const { action, user, role, metadata, customer_id, move_id, lane_id, location_id, driver_id } = options;

    let actionRes = await this.getActionByName(action)
    console.log('actionRes', actionRes)
    if (actionRes && actionRes.data.length === 0) throw new Error('Invalid action');
    let actiontype_id = actionRes.data[0].id;

    if (!actiontype_id) throw new Error('Action is required');
    if (typeof actiontype_id != 'number') throw new Error('Action ID must be a number');

    if (!(typeof user === 'string' && user && user.length > 0)) throw new Error('User is required');
    if (!(typeof role === 'string' && role && role.length > 0)) throw new Error('Role is required');

    let event_time_utc = new Date().toISOString();

    let roleRes = await events.getRoleByName(role);
    console.log('roleRes', roleRes, 
    // roleRes.data[0]
    );
    if (roleRes && roleRes.data.length === 0) throw new Error('Invalid role');
    let role_id = roleRes.data[0].id;

    if (metadata && typeof metadata !== 'object') throw new Error('Metadata must be object');
    if (customer_id && typeof customer_id !== 'number') throw new Error('customer_id must be number');
    if (move_id && typeof move_id !== 'number') throw new Error('move_id must be number');
    if (lane_id && typeof lane_id !== 'number') throw new Error('lane_id must be number');
    if (location_id && typeof location_id !== 'number') throw new Error('location_id must be number');
    if (driver_id && typeof driver_id !== 'number') throw new Error('driver_id must be number');

    //Build an event record for insertion (this is the eventlogs table in the DB)
    let eventlog = {
      event_time_utc: event_time_utc,
      actiontype_id,
      user,
      role_id,
      metadata,
      customer_id,
      move_id,
      lane_id,
      location_id,
      driver_id,
    };

    console.log('events.build produced: ', eventlog);

    return eventlog;
  },

  /** Insert event record into events
   * @param {Object} eventlog - eventlog object to insert
   * @return {Object} response object from gql
   */
  create: eventlog => {
    return _parent.gql.mutation(
      gql`
        mutation sdk_insert_eventlog($eventlogObj: [eventlogs_insert_input!]!) {
          insert_eventlogs(objects: $eventlogObj) {
            affected_rows
            returning {
              ...Eventlog
            }
          }
        }
        ${_parent.fragments.eventlog()}
      `,
      { eventlogObj: eventlog }
    );
  },

  /***
   * Get a role by name if it exists.
   *
   * @param  {String} name - The name of the role to fetch.
   * @returns {Object} The role record from the db if it's found
   */
  getRoleByName: name => {
    return _parent.gql.query(
      gql`
        query get_roles_by_name($name: String!) {
          roletypes(where: { name: { _eq: $name } }) {
            id
            name
          }
        }
      `,
      { name: name }
    );
  },


  /***
   * Get a action by name if it exists.
   *
   * @param  {String} name - The name of the action to fetch.
   * @returns {Object} The action record from the db if it's found
   */
  getActionByName: name => {
    return _parent.gql.query(
      gql`
        query get_actions_by_name($name: String!) {
          actiontypes(where: { name: { _eq: $name } }) {
            id
            name
          }
        }
      `,
      { name: name }
    );
  },

  //PURGE EXPIRED
  /*Each type of eventlog can be kept for a different length of time. 
    So we look up each action type and the expiry duration, then search for all events that are older 
    than that length of time and delete those records*/

  /***
   * Delete expired eventlogs
   *
   * @returns {Object} The actiontype record from the db if it's found
   */
  deleteExpiredEvents: async function () {
    try {
      //Get actiontypes
      let actiontypesRes = await this.getActionTypes();
      let actiontypesData = actiontypesRes.data;
      //Calc expired date for each actiontype
      let actionsArr = actiontypesData.map(action => {
        return { id: action.id, expiredDate: this.calcExpiredDate(action.expiry) };
      });
      //Build where clause for delete_eventlogs
      let clauseArray = [];
      for (var i = 0; i < actionsArr.length; i++) {
        let clause = `{
          _and: { actiontype_id: { _eq: ${actionsArr[i].id} } },
          created_at_utc: { _lt: "${actionsArr[i].expiredDate}" },
        }`;
        clauseArray.push(clause);
      }
      log && console.log('caluseArray', `${clauseArray}`);
      //delete where created_at < expiredDate
      let res = await this.deleteExpired(clauseArray);
      log && console.log(res);
      return res;
    } catch (err) {
      //catches type errors, etc
      console.error('Error deleting expired events', err);
      throw err;
    }
  },

  //Find the expiration date using expiry.
  /*Example: if expiry is quivalent to two weeks, and today is the 20th, 
    anything created before the 6th should be deleted.  
    This function will return the date of the 6th in ISO string format*/
  calcExpiredDate: function (expiry) {
    if (typeof expiry !== 'number') {
      throw new Error('invalid expiry input');
    }
    let now = new Date(); //Returns date as miliseconds since 1970
    let seconds = Date.parse(now) / 1000;
    let expiredDateUnix = (seconds - expiry) * 1000;
    let expiredDateISOstring = new Date(expiredDateUnix).toISOString();
    return expiredDateISOstring;
  },

  getActionTypes: async function () {
    return _parent.gql.query(
      gql`
        query get_action_types_with_expiry {
          actiontypes {
            id
            name
            expiry
          }
        }
      `
    );
  },

  /** Look up all expired events
   * @param {Int} currentDate -  the date call is being made
   * @return {Object} response object from Hasura, should contain all expired events
   */
  deleteExpired: async function (queryArray) {
    return _parent.gql.mutation(
      gql`
        mutation delete_expired_eventlogs {
          delete_eventlogs(where: {_or: [${queryArray}]}) {
          affected_rows
          returning {
            id
            created_at_utc
            actiontype_id
          }
        }
      }`
    );
  },

  /*TODO: figure out a method for adding eventlogs to other mutations 
  on the fly so both can be inserted in a single transaction */



};
module.exports = events;
